import { render, staticRenderFns } from "./cardsView.vue?vue&type=template&id=6165e3bf&"
import script from "./cardsView.vue?vue&type=script&lang=js&"
export * from "./cardsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports